export default "__VITE_ASSET__0KIiM2py__"